import styled from 'styled-components';

export const AcountDetailsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 20px;
`;

export const Separator = styled.hr`
    margin: 20px 0;
`;

export const ContentWrapper = styled.div`
    padding: 10px 7px 10px 7px;
`;

export const PaymentDue = styled.div`
    color: #222a34;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 19px;
`;

export const DateText = styled.div<any>`
    color: ${({ textColor }) => textColor || '#222a34'};
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    font-weight: normal;
`;

export const CardTitle = styled.div<any>`
    color: ${({ theme: { colors }, textColor }) => textColor || colors.cyanDarkBlue};
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 21px;
    margin-bottom: 6px;
    @media screen and (max-width: 800px) {
        margin-bottom: 12px;
    }
`;

export const AmtText = styled.div<any>`
    color: #222a34;
    font-size: 36px;
    letter-spacing: 0;
    line-height: 42px;
    margin-bottom: 11px;
    font-weight: 300;

    ${({ isPastDue }) =>
        isPastDue &&
        `
    color: #D63D34;
    font-weight: 500;
    `}
`;

export const MinDueText = styled.div`
    color: #222a34;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    font-weight: normal;
`;
